export const SET_PATIENT_DETAILS = 'SET_PATIENT_DETAILS'
export function setPatientDetails(payload) {
  return {
    type: SET_PATIENT_DETAILS,
    payload
  }
}